import { Skeleton } from "antd";

import "./TextSkeleton.style.less";

const TextSkeleton = (props) => {
  return (
    <Skeleton
      title={{ className: "text-skeleton-title" }}
      paragraph={false}
      active={true}
      round={false}
      {...props}
    />
  );
};

export default TextSkeleton;
